{
  "name": "@webapp/source",
  "version": "1.6.1",
  "packageManager": "pnpm@11.1.1",
  "license": "MIT",
  "scripts": {
    "prepare": "husky",
    "release": "semantic-release",
    "lint": "eslint 'apps/**/*.{ts,js,jsx,tsx}' 'libs/**/*.{ts,js,jsx,tsx}'",
    "lint:fix": "eslint 'apps/**/*.{ts,js,jsx,tsx}' 'libs/**/*.{ts,js,jsx,tsx}' --fix",
    "agents:local": "nx serve agents --configuration=local",
    "agents:dev": "nx serve agents --configuration=development",
    "agents:prod": "nx serve agents --configuration=production",
    "agents:staging": "nx serve agents --configuration=staging",
    "payments:dev": "nx serve payments-portal --configuration=development",
    "payments:prod": "nx serve payments --configuration=production",
    "payments:staging": "nx serve payments --configuration=staging",
    "auth:dev": "nx serve authentication --configuration=development",
    "auth:prod": "nx serve authentication --configuration=production",
    "auth:staging": "nx serve authentication --configuration=staging",
    "quoter:local": "nx serve public-quoter --configuration=local",
    "quoter:dev": "nx serve public-quoter --configuration=development",
    "quoter:prod": "nx serve public-quoter --configuration=production",
    "quoter:staging": "nx serve public-quoter --configuration=staging",
    "mobile:dev": "nx serve mobile --configuration=development",
    "mobile:build": "nx build mobile --configuration=development",
    "mobile:sync": "nx cap-sync mobile"
  },
  "private": true,
  "pnpm": {
    "onlyBuiltDependencies": [
      "@parcel/watcher",
      "@swc/core",
      "esbuild",
      "less",
      "lmdb",
      "msgpackr-extract",
      "nx"
    ]
  },
  "dependencies": {
    "@angular/cdk": "20.2.14",
    "@angular/common": "20.3.33",
    "@angular/compiler": "20.3.33",
    "@angular/core": "20.3.33",
    "@angular/forms": "20.3.33",
    "@angular/material": "20.2.14",
    "@angular/platform-browser": "20.3.33",
    "@angular/router": "20.3.33",
    "@auth0/angular-jwt": "5.2.0",
    "@capacitor/android": "8.5.3",
    "@capacitor/app": "8.0.1",
    "@capacitor/browser": "8.0.5",
    "@capacitor/camera": "8.2.0",
    "@capacitor/device": "8.0.2",
    "@capacitor/network": "8.0.1",
    "@capacitor/push-notifications": "8.0.3",
    "@capacitor/splash-screen": "8.0.1",
    "@capgo/capacitor-updater": "8.45.10",
    "@maskito/angular": "3.10.2",
    "@maskito/core": "3.10.2",
    "@maskito/kit": "3.10.2",
    "chart.js": "4.5.0",
    "gleap": "15.3.2",
    "ngx-mask": "20.0.2",
    "rxjs": "~7.8.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "1.19.4",
    "@analogjs/vitest-angular": "1.19.4",
    "@angular-devkit/core": "20.3.33",
    "@angular-devkit/schematics": "20.3.33",
    "@angular/animations": "20.3.33",
    "@angular/build": "20.3.33",
    "@angular/cli": "20.3.33",
    "@angular/compiler-cli": "20.3.33",
    "@angular/language-service": "20.3.33",
    "@capacitor/cli": "8.5.3",
    "@capacitor/core": "8.5.3",
    "@eslint/js": "9.8.0",
    "@nx/angular": "21.3.0",
    "@nx/eslint": "21.3.0",
    "@nx/eslint-plugin": "21.3.0",
    "@nx/js": "21.3.0",
    "@nx/vite": "21.3.0",
    "@nx/web": "21.3.0",
    "@nx/workspace": "21.3.0",
    "@schematics/angular": "20.3.33",
    "@semantic-release/changelog": "6.0.3",
    "@semantic-release/git": "10.0.1",
    "@semantic-release/github": "11.0.3",
    "@semantic-release/npm": "10.0.6",
    "@swc-node/register": "~1.9.1",
    "@swc/core": "~1.5.7",
    "@swc/helpers": "~0.5.11",
    "@types/node": "18.16.9",
    "@typescript-eslint/utils": "8.32.0",
    "@vitest/coverage-v8": "3.0.5",
    "@vitest/ui": "3.0.5",
    "angular-eslint": "20.5.1",
    "eslint": "9.32.0",
    "husky": "9.1.7",
    "jiti": "2.4.2",
    "jsdom": "~22.1.0",
    "lint-staged": "16.1.4",
    "nx": "21.3.0",
    "prettier": "^2.6.2",
    "semantic-release": "24.1.0",
    "tailwindcss": "3.4.17",
    "tslib": "2.3.0",
    "typescript": "5.8.2",
    "typescript-eslint": "8.32.0",
    "vite": "6.0.0",
    "vitest": "3.0.5"
  }
}
